import { useMemo } from 'react';
import { useFeatureFlagContext } from 'webReservations/featureFlags';
import {
  OLD_RESERVATION_DETAILS_PATH,
  RESERVATION_DETAILS_PATH,
} from 'webReservations/paths';
import {
  guestReservationPath,
  legacyRestaurantBasePath,
  newGuestLandingBasePath,
  newGuestModifyReservePath,
  newGuestModifyWelcomePath,
} from 'webReservations/utils/pathHelpers';
import type { Restaurant } from 'webReservations/restaurant/apiHelpers';

type RestaurantSlugs = Pick<Restaurant, 'locationSlug' | 'nameSlug'>;

export const useGuestLandingPaths = () => {
  const { isEnabled } = useFeatureFlagContext();
  const useNewGuestLanding = isEnabled('newGuestLandingPage');

  return useMemo(
    () => ({
      useNewGuestLanding,
      legacyReservationDetailsPath: useNewGuestLanding
        ? OLD_RESERVATION_DETAILS_PATH
        : RESERVATION_DETAILS_PATH,
      legacyRestaurantBasePath: (restaurant: RestaurantSlugs) =>
        legacyRestaurantBasePath(restaurant, { useNewGuestLanding }),
      newGuestLandingBasePath: (restaurant: RestaurantSlugs) =>
        newGuestLandingBasePath(restaurant),
      reservationDetailsPath: (
        reservationId: string,
        restaurant: RestaurantSlugs,
      ) => guestReservationPath(reservationId, restaurant),
      newGuestModifyWelcomePath: (
        restaurant: RestaurantSlugs,
        reservationId: string,
        searchParams?: URLSearchParams | string,
      ) => newGuestModifyWelcomePath(restaurant, reservationId, searchParams),
      newGuestModifyReservePath: (
        restaurant: RestaurantSlugs,
        params: {
          date: string;
          guestCount: number;
          time: string;
          reservationId: string;
        },
      ) => newGuestModifyReservePath(restaurant, params),
    }),
    [useNewGuestLanding],
  );
};
